<template>
  <div>
    <div v-if="allowedState.length > 2" class="state-menu state-menu col-md-12">
      <nav
        class="navbar navbar-expand navbar-light bg-light"
        style="padding: 0px;"
      >
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div  :style="isSushiHub && 'background: #f04653; margin-top:0.7rem'" :class="isSushiHub  && 'p-2'" class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
            <li class="nav-item" v-for="st in this.allowedState" :key="st">
              <a
                class="nav-link"
                style="padding-left: 0.38rem; padding-right: 0.38rem;"
                :class="{ active: activeState === st, 'sushi-state-text-mobile montserrat-700' : isSushiHub &&  activeState !== st, 'sushi-state-text-white-mobile montserrat-700' : activeState === st && isSushiHub }"
                @click.prevent="filterStore(st)"
                href="#"
                >{{ st == "All" ? $t("message.all") : st }}</a
              >
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div
      v-if="show"
      class="mobile-resturants container"
      :style="restaurantsContainerStyles"
    >
      <div
        v-for="rs in orderedResturants"
        :key="rs.ID"
        class="row"
        @click="navigateToStore(rs)"
      >
        <div class="triangle-container"  v-if="storeClosed(rs)">
          <div
            class="triangle-topright-img"
          >
            <span>
              {{ $t("message.closed") }}
            </span>
          </div>
        </div>

        <div class="item " >
          <div
            class="item-img"
            v-if="!isSushi"
            :style="{ 'background-image': 'url(' + rs.ProfileImage || '' + ')' }"
          >
          </div>
          <div>
            <div class="item-details with-image">
              <h1 v-if="!isSushi"  :class="isSushiHub ? 'montserrat-700 item-title-sushi' : 'item-title'" >{{ rs.Name }}</h1>
              <p class="item-subtitle" :class="isSushiHub && 'montserrat-700'">{{ rs.StoreTitle }}</p>

              <p class="item-subtitle"  :class="isSushiHub && 'montserrat-400 styled-address'">
                {{ rs.Location.Address }}
              </p>
              <p class="item-subtitle"  :class="isSushiHub && 'montserrat-400 styled-address'">

                {{ rs.Location.Suburb }} {{ rs.Location.State }} {{ rs.Location.Postcode }}
              </p>


            </div>
            <h2 class="item-hours"  :class="isSushiHub && 'montserrat-400'">
              <div v-if="getOperatingHours(rs)" :class="!isSushiHub ? 'color-gray' : 'montserrat-400'">
                {{ isSushiHub ? '' :  $t("message.open") }}
                <span>{{ getOperatingHours(rs, isSushiHub).openTime }}</span>
                {{ $t("message.toName") }}
                <span>{{ getOperatingHours(rs, isSushiHub).closeTime }}</span>
              </div>
            </h2>
          </div>

          <span v-if="pos" class="item-loc"  :class="isSushiHub && 'montserrat-400'">
            <span class="material-icons">near_me</span>
            {{ distance(rs.Location.Latitude, rs.Location.Longitude) }}km
            {{ $t("message.away") }}
          </span>
        </div>
      </div>

    <terms-and-condition />
    </div>
    <div v-else>
      <message :message="getNoStoreAvailableInDatabaseLang" v-show="!busy" />
      <progressindicator
        v-show="busy"
        style="opacity: 0.4;"
      ></progressindicator>
    </div>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/master/Resturant/ResturantsFilter.js";
import Progressindicator from "../../progressindicator";
import Message from "../../shared/Message";
import TermsAndCondition from "@/components/sushiHub/termsAndCondition";

export default {
  components: {TermsAndCondition, Progressindicator, Message },
  filters: {
    ...shared.filters,
  },
  props: {
    filterQuery: {
      type: String,
      default: "all",
    },
    activeState: {
      type: String,
      default: "All",
    },
  },
  data() {
    return {
      populars: [],
      pos: null,
      busy: false,
      states: ["All", "ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],
    };
  },
  computed: {
    ...shared.computed,
    hasLogo() {
      return this.hqDoc ? this.hqDoc.Logo : null;
    },

    isSushi() {
      return this.hqDoc && this.hqDoc.IsSushiHub;
    },
    isSushiHub() {
      return this.hqDoc && this.hqDoc.IsSushiHub;
    },
    restaurantsContainerStyles() {
      return this.hasLogo ? {'margin-top': '43px'} : {'margin-top': '-13px'};
    },
  },
  watch: {
    filterQuery(newValue) {
      this.populars = [];
      if (newValue === "all") {
        this.getStores();
      } else {
        this.getnearStores();
      }
    },
  },
  created() {
    this.checkLocation();
    this.getStores();
  },
  methods: {
    ...shared.methods,
  },
};
</script>
